export const myProfile = "/user/my-profile";
export const updateUserProfile = "/user/update-user-profile";
